import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import cartIcon from './icon-order-active.svg';
// import analyticsIcon from './icon-analytics-active.svg';
import { NavLink, Link } from 'react-router-dom';
import { orderDashboardPath } from 'utils/paths';

const text = {
  isLoading: 'Loading...',
};

const Sidenav = ({
  analyticsNav,
  isLoading,
  isSeriesDetailPath,
  logo,
  orderNav,
  orderSideLinkActive,
  webshopBrand,
}) =>
  isSeriesDetailPath ? (
    <div className={styles.sidenavThin}>
      {isLoading ? (
        <div>{text.isLoading}</div>
      ) : (
        <div className={styles.logobox}>
          <img src={logo} alt="logo" />
        </div>
      )}
      <ul className={styles.sidenavLinks}>
        <li>
          <Link to={orderDashboardPath} className={orderSideLinkActive}>
            <img src={cartIcon} className={styles.icon} alt="cart-icon" />
          </Link>
        </li>
        {/* <li>
          <NavLink
            exact
            to={analyticsPath}
            className={styles.sidenavLink}
            activeClassName={styles.sidenavLinkActive}
          >
            <img
              src={analyticsIcon}
              className={styles.icon}
              alt="analytics-icon"
            />
          </NavLink>
        </li> */}
      </ul>
    </div>
  ) : (
    <div className={styles.sidenav}>
      {isLoading ? (
        <div>{text.isLoading}</div>
      ) : (
        <div className={styles.logobox}>
          <img src={logo} alt="logo" />
          <span className={styles.logo}>{webshopBrand}</span>
        </div>
      )}
      <ul className={styles.sidenavLinks}>
        <li>
          <NavLink
            exact
            to={orderDashboardPath}
            className={orderSideLinkActive}
          >
            <img src={cartIcon} className={styles.icon} alt="cart-icon" />
            <span>{orderNav}</span>
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            exact
            to={analyticsPath}
            className={styles.sidenavLink}
            activeClassName={styles.sidenavLinkActive}
          >
            <img
              src={analyticsIcon}
              className={styles.icon}
              alt="analytics-icon"
            />
            <span>{analyticsNav}</span>
          </NavLink>
        </li> */}
      </ul>
    </div>
  );

export default enhance(Sidenav);
